// ANCHOR Base
import { Block } from 'baseui/block';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { ContentWideTabs } from '@lyon/components/utils/ContentWideTabs';

// ANCHOR Styles
import { BLOCK, TAB } from './styles';

// ANCHOR Constants
import { TABS } from './constants';

export const LyonUpdateFormSidebarTabs = constant(() => (
  <Block overrides={BLOCK}>
    <ContentWideTabs tabs={TABS} overrides={TAB} />
  </Block>
));
